<template>
    <div>

        <!--            :max-width="isEdit ? '600px' : 'none'"-->
        <v-dialog
            v-model="$props.params.manageAppsDialog"
            transition="dialog-bottom-transition"
            :fullscreen="true"
            @keydown.esc="closeManageAppsDialog()"
            @click:outside="closeManageAppsDialog()"
        >
            <v-card class="container">
                <v-form>
                    <v-toolbar
                        color="primary"
                        dark
                        :class="dialogHeadingClasses()"
                    >
                        <v-icon v-text="icons.mdiApps" class="mr-3"></v-icon>
                        <div>{{ $gettext('Manage Apps') }}</div>
                        <v-spacer></v-spacer>
                        <v-icon class="mr-2" @click.native.stop="closeManageAppsDialog()"
                                v-text="icons.mdiClose"></v-icon>

                    </v-toolbar>

                    <v-divider></v-divider>

<!--                    {{ $props.params }}-->

<!--                    <v-row class="my-4 mx-6">
                        <v-col>
                            <mobile-apps-path
                                :group="configurations[currentSelectedConfigurationIndex]['value']['user_group']"
                                :user="configurations[currentSelectedConfigurationIndex]['value']['user']"
                                :device="configurations[currentSelectedConfigurationIndex]['value']['device']">
                            </mobile-apps-path>
                        </v-col>
                    </v-row>-->

                    <!-- This is useful when a user adds a phone but does not choose a phone model. The v-if condition here is very important otherwise, it will appear for even valid configurations -->
                    <configure-device
                        v-if="currentSelectedConfiguration && currentSelectedConfigurationIndex > -1 && Object.keys(configurations[currentSelectedConfigurationIndex].value.phone_model).length < 1"
                        :chosen-model="chosenModel"
                        @update-chosen-model="chosenModelValue => updateChosenModel(chosenModelValue)"
                        @update-folder-name="folderNameValue => updateFolderName(folderNameValue)"
                        @update-phone-type-index="phoneTypeIndexValue => updatePhoneTypeIndex(phoneTypeIndexValue)"
                        @update-selected-template="selectedTemplateValue => updateSelectedTemplate(selectedTemplateValue)"
                        class="ma-6"
                    ></configure-device>

                    <v-row class="mx-6 mt-6" v-if="currentConfigurationHasPhoneModel">
                        <v-col class="shrink">
                            <left-device @update:appFilterText="(val) => this.appFilterText = val" :class="{'mx-4': $vuetify.breakpoint.mdAndUp}"></left-device>
                        </v-col>
                        <v-col class="grow">
                            <mobile-apps-path
                                :group="configurations[currentSelectedConfigurationIndex]['value']['user_group']"
                                :user="configurations[currentSelectedConfigurationIndex]['value']['user']"
                                :device="configurations[currentSelectedConfigurationIndex]['value']['device']">
                            </mobile-apps-path>
                            <app-store v-if="currentSelectedConfigurationIndex > -1"></app-store>
                        </v-col>
                    </v-row>

                </v-form>
            </v-card>
            <snackbar ref="snackbar"></snackbar>
        </v-dialog>

    </div>
</template>
<style type="text/scss">
.add-rule-radio-margin .v-input--selection-controls {
    margin-top: 0;
}

</style>

<script>

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinConfigUsers from '@/mixins/database/MixinConfigUsers'
import MixinVuelidate from '@/mixins/MixinVuelidate'
import {mapWritableState} from 'pinia'
import {usePhoneTypesStore} from '@/stores/PhoneTypesStore'
import ConfigureDevice from "@/components/tabs/mobile/ConfigureDevice.vue";
import {usePhonesStore} from "@/stores/PhonesStore";
import AppStore from "@/components/devices/AppStore.vue";
import MixinConfiguration from "@/mixins/mobile_apps/MixinConfiguration";
import {findIndex} from "lodash";
import LeftDevice from "@/components/devices/LeftDevice.vue";
import MobileAppsPath from "@/components/devices/MobileAppsPath.vue";

export default {
    components: {MobileAppsPath, LeftDevice, AppStore, ConfigureDevice, Snackbar},
    mixins: [MixinDialog, MixinIcon, MixinStringManipulation, MixinConfigUsers, MixinVuelidate, MixinConfiguration],
    props: {
        params: {
            required: true,
            type: Object,
        },
    },
    watch: {},
    mounted() {

        // let self = this;

        /*let configurationIndex = findIndex(self.configurations, function (c) {

            if (c.value.user_group === self.$props.params.group && c.value.user === self.$props.params.user && c.value.device === self.$props.params.device) {
                self.currentSelectedConfiguration = c.key;
                return true;
            }

            return false;

        })

        if (configurationIndex > -1) {
            self.currentSelectedConfigurationIndex = configurationIndex;
            self.loadAModelIfWeHaveIt()
        }*/

    },
    data() {
        return {
            // chosenModel: '',
            // phoneTypeIndex: '',
            appFilterText: '',
        }
    },

    methods: {

        closeManageAppsDialog() {
            let self = this
            // self.$emit('close-edit-device-name-dialog', 'editDeviceDialog')
            self.$props.params.manageAppsDialog = false
            self.resetForm()
            self.$parent.closeDialog('manageAppsDialog')
        },
        resetForm() {

            let self = this
            self.$v.$reset()
        },
        updateChosenModel(val) {
            this.chosenModel = val;
        },

        updateFolderName(val) {
            this.folderName = val;
        },

        updatePhoneTypeIndex(val) {
            this.phoneTypeIndex = val;
        },

        updateSelectedTemplate(val) {
            this.selectedTemplate = val;
        },
    },
    computed: {

        ...mapWritableState(usePhonesStore, {
            configurations: 'configurations',
            currentSelectedConfiguration: 'currentSelectedConfiguration',
            currentSelectedConfigurationIndex: 'currentSelectedConfigurationIndex',
            chosenModel: 'chosenModel',
        }),

        ...mapWritableState(usePhoneTypesStore, {
            phoneTypes: 'phoneTypes',
            phoneTypeIndex: 'phoneTypeIndex',
            // appsCommon: 'appsCommon',
        }),

        currentConfigurationHasPhoneModel() {
            return Object.keys(this.configurations[this.currentSelectedConfigurationIndex].value.phone_model).length > 0
        },


    },
    validations: {}

}
</script>
